import React from "react";

export const PRESENCE_LABELS = {
  online: "Online",
  away: "Away",
  do_not_disturb: "Do not disturb",
  busy: "Busy",
  offline: "Offline",
};

export const getPresenceKey = (status) => {
  const key = status?.toLowerCase();
  return PRESENCE_LABELS[key] ? key : "offline";
};

// Small status dot for the corner of an avatar
const PresenceDot = ({ status }) => {
  const key = getPresenceKey(status);
  return (
    <span
      className={`ec-presence ec-presence--${key}`}
      role="img"
      aria-label={PRESENCE_LABELS[key]}
    />
  );
};

export default PresenceDot;
